import { css } from '@emotion/react';
import { alpha, lighten } from '@mui/material/styles';

// The bar is a lighter shade of the CTA colour so it does not compete with the
// journey's buttons; the percentage keeps the full CTA colour.
const BAR_LIGHTEN_COEFFICIENT = 0.5;
const LABEL_TEXT_OPACITY = 0.7;

// Used when a theme defines no continue-button or text colour, so the bar
// still renders instead of throwing on `lighten(undefined)`/`alpha(undefined)`.
const DEFAULT_TINT = '#0da587';
const DEFAULT_TEXT_COLOUR = 'rgb(0, 0, 0)';

const makeJourneyProgressStyles = ({ theme }) => {
  const { palette } = theme.mvf;
  const ctaColour = palette.component?.continueButtonColor ?? DEFAULT_TINT;
  const textColour = palette.text?.primaryTextColor ?? DEFAULT_TEXT_COLOUR;

  return {
    container: css({
      marginBottom: theme.mvf.spacing.large,
    }),
    labelRow: css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      marginBottom: 8,
    }),
    label: css({
      '& p': {
        color: alpha(textColour, LABEL_TEXT_OPACITY),
      },
    }),
    percentage: css({
      '& p': {
        color: ctaColour,
        fontWeight: theme.mvf.typography.weight.thick,
      },
    }),
    bar: css({
      height: 8,
      borderRadius: 4,
      backgroundColor: palette.component?.progressBarUnfilledColor,
      '& .MuiLinearProgress-bar': {
        borderRadius: 4,
        backgroundColor: lighten(ctaColour, BAR_LIGHTEN_COEFFICIENT),
      },
    }),
  };
};

export default makeJourneyProgressStyles;
